import React from "react";

export default function Tags({ data }) {
  return (
    <div className="border rounded-[14px] overflow-hidden border-input  bg-gray-50 relative mt-4">
      <div className="flex pt-4 pb-3 px-4 justify-between items-center ">
        <span className="text-[16px] text-text-700 mr-3 font-bold">Tags</span>
      </div>
      <div className="px-4 mb-4">
        {data &&
          data &&
          data.length > 0 &&
          data.map((item) => (
            <span className="inline-block text-[12px] bg-purple-50 text-purple-700 border border-purple-200 px-2 py-1 rounded-[20px] mr-3 mb-3">
              {item}
            </span>
          ))}
      </div>
    </div>
  );
}
